import { render, staticRenderFns } from "./CarData.vue?vue&type=template&id=28d88699"
import script from "./CarData.vue?vue&type=script&lang=js"
export * from "./CarData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports